import { useModals } from "@/features/modals/hooks";
import { type QuotationsWidgetList } from "@repo/api";
import { LightMode, ListView, ListViewItem } from "@repo/skapa";
import { t, useTranslation } from "@repo/translation";
import {
  SimpleLabelField,
  localizeDate,
  translateQuotationStatus,
} from "@repo/ui";

interface QuotationsListProps {
  quotations: QuotationsWidgetList[];
}

export const QuotationsList = ({ quotations }: QuotationsListProps) => {
  const { pushModal } = useModals();
  const { dateFnsLocale } = useTranslation();
  return (
    <ListView id="workspace-quotation-list">
      {quotations.map((quotation) => (
        <ListViewItem
          key={quotation.quoteId}
          control="navigational"
          title={quotation.quoteId}
          description={
            <SimpleLabelField
              label={t("label.status")}
              value={translateQuotationStatus(quotation.status)}
              color={LightMode.colourTextAndIcon2}
              small
            />
          }
          addOn={
            <SimpleLabelField
              label={t("label.expiry_date")}
              value={
                quotation.expiryDate
                  ? localizeDate(quotation.expiryDate, dateFnsLocale)
                  : "-"
              }
              color={LightMode.colourTextAndIcon3}
              small
            />
          }
          onClick={() => {
            pushModal({
              type: "QUOTATION",
              quotationId: quotation.quoteId ?? "",
              projectId: quotation?.opportunityId,
            });
          }}
        />
      ))}
    </ListView>
  );
};
